import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MerchantStoreItem } from '../types/merchant-store-item.type';

export const duplicateAddressValidator =
  (stores: MerchantStoreItem[]): ValidatorFn =>
  (
    control: AbstractControl<{ description: string } | null>
  ): ValidationErrors | null => {
    const isDuplicate = stores?.some(
      (store) => store.Address === control.value?.description
    );

    return isDuplicate ? { isDuplicate: true } : null;
  };
